export default "skymp5-front/9bb832ceb9c6c826ae733d998bb76371.png";